export enum Priority {
  TOOLBAR = 0,
  SELECTION = 0,
  CONTROL = 1,
  HEADER = 2,
  MODAL_WINDOW = 3,
  MODAL_WINDOW_CONTROL = 4,
}
